import { Inject, Injectable } from '@angular/core';
import { IAutoCompleteService } from '../../../core/component/autocomplete-remote/autocomplete-service.interface';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { HttpClient } from '@angular/common/http';
import { MessageService } from '../../../core/service/message.service';
import { AutoCompleteSelectionItem } from '../../../core/component/autocomplete-remote/autocomplete-selection-item';
import { catchError, map, Observable } from 'rxjs';
import { Resource } from '../../../fault-notification/model/resource';

@Injectable()
export class UserResourceService implements IAutoCompleteService {
  private readonly _endpoint: string;

  constructor(
    private _client: HttpClient,
    private _messageService: MessageService,
    @Inject(APP_CONFIG) config: IAppConfig
  ) {
    this._endpoint = `${config.apiEndpointV2}/user-resource`;
  }

  getSelectionItem(id: string): Observable<AutoCompleteSelectionItem<Resource>> {
    return this._client.get<Resource>(`${this._endpoint}/selectionItem/${id}`).pipe(
      map(data => this.createAutoCompleteSelectionItem(new Resource(data))),
      catchError(e => {
        this._messageService.showError(e);
        return [];
      })
    );
  }

  getSelection(filter: string, options?: any, page?: number, maxItems?: number): Observable<AutoCompleteSelectionItem<Resource>[]> {
    const queryArgs = {
      filter: filter,
      maxItems: maxItems || 20,
    };
    if (options) queryArgs['options'] = options;
    if (page > 0) queryArgs['page'] = page;

    return this._client.post<Resource[]>(`${this._endpoint}/selection`, queryArgs).pipe(
      map(data => data.map(item => this.createAutoCompleteSelectionItem(new Resource(item)))),
      catchError(e => {
        this._messageService.showError(e);
        return [];
      })
    );
  }

  private createAutoCompleteSelectionItem(entity: Resource): AutoCompleteSelectionItem {
    return new AutoCompleteSelectionItem(entity.name, entity.id, entity, entity.name);
  }
}
